<template>
  <div>
    <FormItem label="说完转接">
      <i-switch
        :value="value.hmc_after_play"
        @on-change="changeAfterPlay"
      />
    </FormItem>
    <FormItem v-if="isGookiEnv" ref="secondsField" label="几秒后转接" prop="hmc_delay" :rules="secondsRule">
      <i-switch :value="value.can_delay_hmc" @on-change="changeAfterSeconds" />
      <div class="transfer-seconds">
        <InputNumber
          :value="value.hmc_delay"
          :min="1"
          :max="maxSeconds"
          :step="1"
          :precision="0"
          :disabled="!value.can_delay_hmc"
          placeholder="请输入秒数"
          aria-label="转接等待秒数"
          @input="changeSeconds"
        />
        <span class="unit">毫秒</span>
      </div>
      <div class="transfer-hint">与“说完转接”互斥，开启后自动关闭另一项</div>
    </FormItem>
  </div>
</template>

<script>
import { validateTransferAfterSeconds } from '@/utils/nodeTransfer';
import { isGookiEnv } from '@/utils/env';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isGookiEnv,
    maxSeconds() {
      return Number.MAX_SAFE_INTEGER;
    },
    secondsRule() {
      return {
        validator: (rule, value, callback) => validateTransferAfterSeconds(
          rule, value, callback, this.value.can_delay_hmc,
        ),
        trigger: 'change',
      };
    },
  },
  methods: {
    changeAfterPlay(enabled) {
      this.$emit('input', {
        ...this.value,
        hmc_after_play: enabled,
        can_delay_hmc: enabled ? false : this.value.can_delay_hmc,
      });
      this.validateSeconds();
    },
    changeAfterSeconds(enabled) {
      this.$emit('input', {
        ...this.value,
        can_delay_hmc: enabled,
        hmc_after_play: enabled ? false : this.value.hmc_after_play,
      });
      this.validateSeconds();
    },
    changeSeconds(seconds) {
      this.$emit('input', { ...this.value, hmc_delay: seconds });
      this.validateSeconds();
    },
    validateSeconds() {
      // 等父表单更新 model 后再校验，关闭任一模式时也同步清除失效错误。
      this.$nextTick(() => {
        if (this.$refs.secondsField) this.$refs.secondsField.validate('change');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.transfer-seconds {
  margin-top: 10px;
}
.unit {
  margin-left: 8px;
}
.transfer-hint {
  color: #808695;
  font-size: 12px;
}
</style>
